import { cn } from "@bidbattles/bloks/lib/ui";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BannerCard, BannerTitle } from "./ui/banners";

function RestrictedJurisdictionsBanner({
	className,
}: React.ComponentProps<"div">) {
	return (
		<BannerCard className={cn("text-gray-700 w-full", className)}>
			<BannerTitle className="text-danger">
				<FontAwesomeIcon icon={faBan} />
				Restricted Jurisdictions
			</BannerTitle>
			<p>
				Users from countries outside the European Union are not permitted to use
				BidBattles. Attempting to use VPNs or other methods to circumvent
				geographic restrictions is strictly prohibited.
			</p>
		</BannerCard>
	);
}

export { RestrictedJurisdictionsBanner };
